// extracted by mini-css-extract-plugin
export default {"container":"ReminderList_container__C7YEI","content":"ReminderList_content__hQwNu"};